var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"pagination-btn",on:{"click":_vm.passPageNumberToParent}},[_vm._v(" "+_vm._s(_vm.pageNumber)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }